<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">Träger</h3>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <div v-if="loading" class="loading-container">
          <i class="fa fa-cog fa-spin"></i>
          <span>Daten werden geladen...</span>
        </div>
        <div class="card" v-if="!loading">
          <div class="card-body">
            <div class="header-row">
              <h4 class="card-title">Träger ({{ traeger.length }})</h4>
              <b-button variant="success" @click="openCreate">Neuer Träger</b-button>
            </div>

            <form class="forms-sample">
              <b-form-group label="" label-for="input1">
                <b-form-input v-model="searchfilter" type="text" id="input1"
                  placeholder="Name, Kindy-ID oder E-Mail..."></b-form-input>
              </b-form-group>
            </form>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="sortable-th" @click="sortBy('name')">Name <i :class="sortIcon('name')"></i></th>
                    <th class="sortable-th" @click="sortBy('kindy_id')">Kindy-ID <i :class="sortIcon('kindy_id')"></i></th>
                    <th class="sortable-th" @click="sortBy('kitas_count')">Kitas <i :class="sortIcon('kitas_count')"></i></th>
                    <th class="sortable-th" @click="sortBy('users_count')">Zugänge <i :class="sortIcon('users_count')"></i></th>
                    <th class="sortable-th" @click="sortBy('email')">Kontakt-E-Mail <i :class="sortIcon('email')"></i></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sortedTraeger" :key="item.uid">
                    <td>
                      <a class="link-col" :href="generateLink(item.uid)">{{ item.name }}</a>
                    </td>
                    <td>{{ item.kindy_id }}</td>
                    <td>{{ item.kitas_count }}</td>
                    <td>{{ item.users_count }}</td>
                    <td>{{ item.email }}</td>
                    <td style="text-align: right">
                      <router-link class="btn btn-outline-primary btn-fw" :to="{
                        name: 'traeger-detail',
                        params: { uid: item.uid },
                      }">Anzeigen</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="sortedTraeger && sortedTraeger.length === 0" class="empty-state">
                <i class="mdi mdi-filter-remove-outline"></i>
                <p>Keine Träger gefunden.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modalCreateTraeger" title="Neuer Träger" size="md" @ok="submitCreate" @hidden="resetCreate"
      ok-title="Anlegen" cancel-title="Abbrechen" :ok-disabled="creating">
      <form class="forms-sample" @submit.prevent>
        <b-form-group label="Kindy-ID (Login-Handle)" label-for="createKindyId">
          <b-form-input v-model="createForm.kindy_id" type="text" id="createKindyId"
            placeholder="z.B. mustertraeger"></b-form-input>
          <small class="text-muted">Nach der Anlage nicht mehr änderbar.</small>
        </b-form-group>
        <b-form-group label="Name" label-for="createName">
          <b-form-input v-model="createForm.name" type="text" id="createName" placeholder="Trägername"></b-form-input>
        </b-form-group>
        <b-form-group label="Straße" label-for="createStreet">
          <b-form-input v-model="createForm.street" type="text" id="createStreet" placeholder="Straße"></b-form-input>
        </b-form-group>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="PLZ" label-for="createZip">
              <b-form-input v-model="createForm.zip" type="text" id="createZip" placeholder="PLZ"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group label="Ort" label-for="createCity">
              <b-form-input v-model="createForm.city" type="text" id="createCity" placeholder="Ort"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-form-group label="Kontakt-E-Mail" label-for="createEmail">
          <b-form-input v-model="createForm.email" type="email" id="createEmail" placeholder="E-Mail"></b-form-input>
        </b-form-group>

        <div class="mt-2 mb-3" style="width: 100%; border-top: 1px solid #e0e0e0;"></div>
        <h5 class="mb-3">Erster Zugang (Admin)</h5>
        <b-form-group label="Name" label-for="createAdminName">
          <b-form-input v-model="createForm.admin_name" type="text" id="createAdminName"
            placeholder="Name des Admins"></b-form-input>
        </b-form-group>
        <b-form-group label="E-Mail" label-for="createAdminEmail">
          <b-form-input v-model="createForm.admin_email" type="email" id="createAdminEmail"
            placeholder="E-Mail des Admins"></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Vue from "vue";
import { getAll, createTraeger } from "@/services/traeger.service";

export default {
  name: "traeger-list",
  data() {
    return {
      loading: true,
      creating: false,
      traeger: [],
      searchfilter: null,
      sortKey: "name",
      sortOrder: "asc",
      createForm: this.emptyCreateForm(),
    };
  },
  computed: {
    filteredTraeger: function () {
      if (!this.searchfilter) {
        return this.traeger;
      }
      const q = this.searchfilter.toString().toLowerCase();
      return this.traeger.filter((item) => {
        return (
          (item.name && item.name.toString().toLowerCase().indexOf(q) !== -1) ||
          (item.kindy_id && item.kindy_id.toString().toLowerCase().indexOf(q) !== -1) ||
          (item.email && item.email.toString().toLowerCase().indexOf(q) !== -1)
        );
      });
    },
    sortedTraeger: function () {
      let list = this.filteredTraeger;
      if (this.sortKey) {
        list = list.slice().sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (valA == null) valA = "";
          if (valB == null) valB = "";

          if (typeof valA === "string" && typeof valB === "string") {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (this.sortOrder === "asc") {
            return valA > valB ? 1 : valA < valB ? -1 : 0;
          } else {
            return valA < valB ? 1 : valA > valB ? -1 : 0;
          }
        });
      }
      return list;
    },
  },
  methods: {
    emptyCreateForm: function () {
      return {
        kindy_id: "",
        name: "",
        street: "",
        zip: "",
        city: "",
        email: "",
        admin_name: "",
        admin_email: "",
      };
    },
    sortIcon: function (key) {
      if (this.sortKey !== key) return "fa fa-sort sort-icon sort-icon-inactive";
      return this.sortOrder === "asc" ? "fa fa-sort-asc sort-icon" : "fa fa-sort-desc sort-icon";
    },
    sortBy: function (key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    generateLink(uid) {
      return this.$router.resolve({
        name: "traeger-detail",
        params: { uid },
      }).href;
    },
    openCreate: function () {
      this.createForm = this.emptyCreateForm();
      this.$bvModal.show("modalCreateTraeger");
    },
    resetCreate: function () {
      this.createForm = this.emptyCreateForm();
    },
    submitCreate: function (bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.createForm.kindy_id || !this.createForm.kindy_id.trim()) {
        Vue.$toast.open({ message: "Kindy-ID ist erforderlich", type: "error", position: "bottom", duration: 2500 });
        return;
      }
      if (!this.createForm.name || !this.createForm.name.trim()) {
        Vue.$toast.open({ message: "Name ist erforderlich", type: "error", position: "bottom", duration: 2500 });
        return;
      }
      if (!this.createForm.admin_email || !this.createForm.admin_email.trim()) {
        Vue.$toast.open({ message: "E-Mail des ersten Admins ist erforderlich", type: "error", position: "bottom", duration: 2500 });
        return;
      }

      this.creating = true;
      createTraeger(this.createForm)
        .then((resp) => {
          this.creating = false;
          Vue.$toast.open({ message: "Träger angelegt, Aktivierungsmail versendet", type: "success", position: "bottom", duration: 2000 });
          this.$bvModal.hide("modalCreateTraeger");
          const newUid = resp && resp.data && resp.data.uid;
          if (newUid) {
            this.$router.push({ name: "traeger-detail", params: { uid: newUid } });
          } else {
            this.loadAll();
          }
        })
        .catch((err) => {
          this.creating = false;
          Vue.$toast.open({
            message: (err && err.message) || "Träger konnte nicht angelegt werden",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    loadAll: function () {
      this.loading = true;
      getAll()
        .then((resp) => {
          this.loading = false;
          this.traeger = (resp.data && (resp.data.traeger || resp.data.departments)) || [];
        })
        .catch((err) => {
          this.loading = false;
          if (err && err.data && err.data.error === "user") {
            localStorage.removeItem("token");
            this.$router.push({ name: "login" });
            return;
          }
          Vue.$toast.open({
            message: (err && err.message) || "Träger konnten nicht geladen werden",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
  },
  mounted() {
    this.loadAll();
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9c9fa6;
}

.loading-container i {
  font-size: 40px;
  margin-bottom: 12px;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.sortable-th:hover {
  color: #198ae3;
}

.sort-icon {
  font-size: 11px;
  margin-left: 4px;
}

.sort-icon-inactive {
  opacity: 0.3;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #9c9fa6;
}

.empty-state i {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

.link-col {
  color: #0077cc;
  text-decoration: none;
}

.link-col:hover {
  color: #005fa3;
}
</style>
